import type { OlProps } from "@components/OlProps.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getCompanyTimeline(tenant: Tenant): OlProps[] {
	return [
		{
			customNumber: "2009",
			desc: "Rok, kdy se sp[[začala psát historie Fastest Solution.]] V počátcích jsme především vyvíjeli weby, e-shop a interní systémy.",
		},
		{
			customNumber: "2016",
			desc: "Nastal čas udělat krok kupředu. V roce 2016 jsme se pustili sp[[do vývoje pokladních systémů a serverových řešení na míru.]]",
		},
		{
			customNumber: "2019",
			desc: "Kdo nejde s dobou, zaostává. Proto jsme modernizovali technologie a začali používat mimo jiné cloud Amazon Web Services. sp[[Fastest Solution se od té doby specializuje na vývoj webových a cloudových aplikací.]]",
		},
		{
			customNumber: "2021",
			desc: "Jednatel sp[[Jakub Tysoň předal vedení firmy]] a jednotlivých projektů do rukou jednoho ze svých „odchovanců“ – tehdejšího sp[[CTO a COO Martina Kučery.]] I díky tomu se firmu podařilo nasměrovat k dalšímu posunu.",
		},
		{
			customNumber: "2023",
			desc: "Jeden z nejvýznamnějších milníků pro firmu jako takovou. V roce 2023 sp[[do Fastest Solution vstoupil investor P4U Invest a.s.]], který nám pomáhá s rozvojem.",
		},
		{
			customNumber: "2025",
			desc: "sp[[Martin Kučera]] byl jmenován sp[[novým CEO společnosti Fastest Solution]]. Společnost pokračuje v růstu a rozšiřování svého portfolia služeb.",
		},
	];
}
